"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyGetListApi = companyGetListApi;
exports.getLogisticsInfoApi = getLogisticsInfoApi;
exports.orderAuditApi = orderAuditApi;
exports.orderDeleteApi = orderDeleteApi;
exports.orderDetailApi = orderDetailApi;
exports.orderDirectRefundApi = orderDirectRefundApi;
exports.orderExcelApi = orderExcelApi;
exports.orderInvoiceListApi = orderInvoiceListApi;
exports.orderInvoiceUpdateApi = orderInvoiceUpdateApi;
exports.orderListApi = orderListApi;
exports.orderLogApi = orderLogApi;
exports.orderMarkApi = orderMarkApi;
exports.orderPrint = orderPrint;
exports.orderPrintReceiptApi = orderPrintReceiptApi;
exports.orderProDetailApi = orderProDetailApi;
exports.orderRefundApi = orderRefundApi;
exports.orderRefuseApi = orderRefuseApi;
exports.orderReviewApi = orderReviewApi;
exports.orderSendApi = orderSendApi;
exports.orderStatisticsApi = orderStatisticsApi;
exports.orderStatusNumApi = orderStatusNumApi;
exports.orderTimeApi = orderTimeApi;
exports.refundListApi = refundListApi;
exports.refundMarkApi = refundMarkApi;
exports.refundOrderDetailApi = refundOrderDetailApi;
exports.refundOrderReceivingApi = refundOrderReceivingApi;
exports.refundOrderReceivingRejectApi = refundOrderReceivingRejectApi;
exports.refundStatusNumApi = refundStatusNumApi;
exports.sheetInfoApi = sheetInfoApi;
exports.statisticsDataApi = statisticsDataApi;
exports.updatePriceApi = updatePriceApi;
exports.videoSendApi = videoSendApi;
exports.writeUpdateApi = writeUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 订单 列表
 * @param prams
 */
function orderListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/order/list',
    method: 'get',
    params: params
  });
}

/**
 * 订单 列表 获取各状态数量
 * @param params
 */
function orderStatusNumApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/order/status/num',
    method: 'get',
    params: params
  });
}

/**
 * 订单 删除
 * @param params
 */
function orderDeleteApi(orderNo) {
  return (0, _request.default)({
    url: "/admin/merchant/order/delete/".concat(orderNo),
    method: 'post'
  });
}

/**
 * 订单 记录
 * @param prams
 */
function orderLogApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/status/list',
    method: 'get',
    params: params
  });
}

/**
 * 订单 详情
 * @param prams
 */
function orderDetailApi(orderNo) {
  return (0, _request.default)({
    url: "/admin/merchant/order/info/".concat(orderNo),
    method: 'get'
  });
}

/**
 * 订单 备注
 * @param prams
 */
function orderMarkApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/order/mark',
    method: 'post',
    data: data
  });
}

/**
 * 订单 发货
 * @param prams
 */
function orderSendApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/order/send',
    method: 'post',
    data: data
  });
}
function orderPrintReceiptApi(orderno) {
  return (0, _request.default)({
    url: '/admin/merchant/order/printreceipt/' + orderno,
    method: 'get'
  });
}

/**
 * 订单 拒绝退款
 * @param prams
 */
function orderRefuseApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/refund/order/refund/refuse',
    method: 'get',
    params: params
  });
}

/**
 * 订单 立即退款
 * @param prams
 */
function orderRefundApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/refund/order/refund',
    method: 'get',
    params: params
  });
}

/**
 * 订单 统计 头部数据
 */
function orderStatisticsApi() {
  return (0, _request.default)({
    url: "/admin/store/order/statistics",
    method: 'get'
  });
}

/**
 * 核销订单 月列表数据
 */
function statisticsDataApi(params) {
  return (0, _request.default)({
    url: "/admin/store/order/statisticsData",
    method: 'get',
    params: params
  });
}

/**
 * 一键改价
 */
function updatePriceApi(data) {
  return (0, _request.default)({
    url: "admin/store/order/update/price",
    method: 'post',
    data: data
  });
}

/**
 *订单统计详情
 */
function orderTimeApi(params) {
  return (0, _request.default)({
    url: "/admin/store/order/time",
    method: 'get',
    params: params
  });
}

/**
 *面单默认配置信息
 */
function sheetInfoApi() {
  return (0, _request.default)({
    url: "/admin/store/order/sheet/info",
    method: 'get'
  });
}

/**
 *面单默认配置信息
 */
function getLogisticsInfoApi(invoiceId) {
  return (0, _request.default)({
    url: "/admin/merchant/order/get/".concat(invoiceId, "/logistics/info"),
    method: 'get'
  });
}

/**
 *视频号物流公司
 */
function companyGetListApi() {
  return (0, _request.default)({
    url: "/admin/pay/component/delivery/company/get/list",
    method: 'get'
  });
}

/**
 *视频号物流公司
 */
function videoSendApi(data) {
  return (0, _request.default)({
    url: "/admin/store/order/video/send",
    method: 'post',
    data: data
  });
}

/**
 *打印小票
 */
function orderPrint(id) {
  return (0, _request.default)({
    url: "/admin/yly/print/".concat(id),
    method: 'get'
  });
}

/**
 *退款列表
 */
function refundListApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/refund/order/list",
    method: 'get',
    params: params
  });
}

/**
 *退商户备注退款订单
 */
function refundMarkApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/refund/order/mark",
    method: 'post',
    data: data
  });
}

/**
 *获取退款订单各状态数量
 */
function refundStatusNumApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/refund/order/status/num",
    method: 'GET',
    params: params
  });
}

/**
 * 订单 核销订单
 * @param data
 */
function writeUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/order/verification",
    method: 'post',
    data: data
  });
}

/**
 * 订单细节详情列表（发货使用）
 * @param orderNo 订单号
 */
function orderProDetailApi(orderNo) {
  return (0, _request.default)({
    url: "/admin/merchant/order/".concat(orderNo, "/detail/list"),
    method: 'get'
  });
}

/**
 * 获取订单发货单列表
 * @param orderNo 订单号
 */
function orderInvoiceListApi(orderNo) {
  return (0, _request.default)({
    url: "/admin/merchant/order/".concat(orderNo, "/invoice/list"),
    method: 'get'
  });
}

/**
 * 平台端退款订单详情
 * @param refundOrderNo 订单号
 */
function refundOrderDetailApi(refundOrderNo) {
  return (0, _request.default)({
    url: "/admin/merchant/refund/order/detail/".concat(refundOrderNo),
    method: 'get'
  });
}

/**
 * 平台端退款订单详情
 * @param params 对象
 */
function orderExcelApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/export/order/excel",
    method: 'get',
    params: params
  });
}

/**
 * 退款单审核
 * @param data 对象
 */
function orderAuditApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/refund/order/audit",
    method: 'post',
    data: data
  });
}

/**
 * 退款单收到退货
 * @param refundOrderNo 退款单号
 */
function refundOrderReceivingApi(refundOrderNo) {
  return (0, _request.default)({
    url: "/admin/merchant/refund/order/receiving/".concat(refundOrderNo),
    method: 'post'
  });
}

/**
 * 退款单拒绝收货
 * @param data
 */
function refundOrderReceivingRejectApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/refund/order/receiving/reject",
    method: 'post',
    data: data
  });
}

/**
 * 商户直接退款
 * @param data
 */
function orderDirectRefundApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/order/direct/refund",
    method: 'post',
    data: data
  });
}

/**
 * 修改发货单配送信息
 * @param data
 */
function orderInvoiceUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/order/invoice/update",
    method: 'post',
    data: data
  });
}
// 订单审核
function orderReviewApi(data) {
  return (0, _request.default)({
    url: 'admin/merchant/order/status/review',
    method: 'post',
    data: data
  });
}